import React, { useState } from 'react';
import axios from 'axios';
import configData from "./config.json";


function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(configData.SERVER_URL+'/users/login', {
        Email: email,
        Password: password,
      });
      const token = response.data.token;
      document.cookie = `agbar_user_token=${token}; path=/;`;
      // Redirigir a la página principal o a la página deseada después del login
      window.location.href = '/product';
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="page">
      <div className="page-single">
        <div className="container">
          <div className="row">
            <div className="col col-login mx-auto">
              <div className="text-center mb-6">
                
              </div>
              <form className="card" onSubmit={handleSubmit}>
                <div className="card-body p-6">
                  <div className="card-title">Login</div>
                  {error && <div className="alert alert-important alert-danger">{error}</div>}
                  <div className="form-group">
                    <label className="form-label">User</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="User name"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <br />
                  <div className="form-group">
                    
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="form-footer">
                    <button type="submit" className="btn btn-primary btn-block">Sign in</button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;